// define config for client here
export default {
  clientNameUseForApiRequest: "stas",
  clientTagId: 10616,
};
